export const nullSaleProduct = {
  id: 0,
  product_code: '',
  product_name: '',
  sale_price: 0,
};